"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VerifyEmailConfirmResponseScheme = exports.VerifyEmailConfirmRequestScheme = exports.VerifyEmailSendResponseScheme = exports.VerifyEmailSendRequestScheme = void 0;
var zod_1 = require("zod");
exports.VerifyEmailSendRequestScheme = zod_1.z.object({
    email: zod_1.z.string(),
});
exports.VerifyEmailSendResponseScheme = zod_1.z
    .object({
    code: zod_1.z.string().nullish(),
    expiresInSeconds: zod_1.z.number(),
    count: zod_1.z.object({
        limit: zod_1.z.number(),
        remain: zod_1.z.number(), // 남은 횟수
    }),
})
    .or(zod_1.z.object({
    code: zod_1.z.string(),
    message: zod_1.z.string(),
}));
exports.VerifyEmailConfirmRequestScheme = zod_1.z.object({
    email: zod_1.z.string(),
    code: zod_1.z.number().or(zod_1.z.string()),
});
exports.VerifyEmailConfirmResponseScheme = zod_1.z.string().or(zod_1.z.object({
    code: zod_1.z.string().nullish(),
    message: zod_1.z.string().nullish(),
}));
